module.exports = __webpack_public_path__ + "static/media/screen_main_plus_7.0f3e32a7.svg";